import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericContainer} from "../../../components/containers/GenericContainer";
import {roleProvider} from "../../../providers/roleProvider";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {userRoleService} from "../../../jwt/_services";

const UserRoleSection = (props) => {
    const path = props.path + "/roles";

    const parentState = useSelector((state) => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject } = parentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const [roleId, setRoleId] = useState(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);


    useEffect(() => {
        const dataRequest = {
            user: { id: domainObject?.id }
        };

        genericIndexedActions.search(path, userRoleService, 0, 1000, dataRequest);
    }, []);

    const onAdd = () => {
        const dataRequest = {
            role: { id: roleId},
            user: { id: domainObject?.id }
        }

        genericIndexedActions.add(path, userRoleService, dataRequest);
    };


    const onRemove = ( _userRole ) => {
        const dataRequest = {
            role: { id: _userRole?.role?.id },
            user: { id: domainObject?.id }
        }

        genericIndexedActions.remove(path, userRoleService, dataRequest);
    };

    const renderContent = (_option, index) => {
        return (
            <div className={'module-menu-item'}>
                <label className="module-menu-item-title">
                    <h3>{ _option?.role?.authority }</h3>
                </label>
                <div className="float-right">
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={'Desvincular'}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={_ => onRemove(_option)}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            {/*GENERIC CONTAINER VINCULAR*/}
            <GenericContainer
                titlle={'Roles'}
                listItems={listDomainObjects}
                renderContent={renderContent}
                loading={loading}

                provider={roleProvider}
                option={roleId}
                setOption={setRoleId}
                onAddItem={onAdd}
            />
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapActionsToProps)(UserRoleSection);
